module.exports = __webpack_public_path__ + "static/media/Logo__MLH.36eaa70d.svg";